import { render, staticRenderFns } from "./PackagePaymentNewModal.vue?vue&type=template&id=030706fe&scoped=true"
import script from "./PackagePaymentNewModal.vue?vue&type=script&lang=ts"
export * from "./PackagePaymentNewModal.vue?vue&type=script&lang=ts"
import style0 from "./PackagePaymentNewModal.vue?vue&type=style&index=0&id=030706fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030706fe",
  null
  
)

export default component.exports